import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
var _excluded = ["alt", "src", "size", "testId"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * @jsxRuntime classic
 * @jsx jsx
 */
import { useEffect, useState } from 'react';

// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766
import { css, jsx } from '@emotion/react';
import { AVATAR_SIZES } from '@atlaskit/avatar';
import TeamIcon from '@atlaskit/icon/glyph/people';
import { N0, N90 } from '@atlaskit/theme/colors';
var ICON_BACKGROUND = "var(--ds-icon-inverse, ".concat(N0, ")");
var ICON_COLOR = "var(--ds-icon-subtle, ".concat(N90, ")");
// used in a size calculation so can't be a token. Without this the avatar looks very squished
var ICON_PADDING = 4;
var avatarDefaultIconStyles = css({
  display: 'flex',
  backgroundColor: ICON_COLOR,
  borderRadius: '50%',
  width: '100%',
  height: '100%',
  justifyContent: 'center',
  alignItems: 'center'
});
var nestedAvatarStyles = Object.entries(AVATAR_SIZES).reduce(function (styles, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
    key = _ref2[0],
    size = _ref2[1];
  return _objectSpread(_objectSpread({}, styles), {}, _defineProperty({}, key, css({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    width: "".concat(size, "px"),
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
    height: "".concat(size, "px"),
    // eslint-disable-next-line @atlaskit/design-system/no-nested-styles, @atlaskit/ui-styling-standard/no-nested-selectors -- Ignored via go/DSP-18766
    '& svg': {
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      width: "".concat(size - ICON_PADDING, "px"),
      // eslint-disable-next-line @atlaskit/ui-styling-standard/no-unsafe-values -- Ignored via go/DSP-18766
      height: "".concat(size - ICON_PADDING, "px")
    }
  })));
}, {});
var avatarImageStyles = css({
  display: 'flex',
  flex: '1 1 100%',
  width: '100%',
  height: '100%'
});

/**
 * __Avatar image__
 *
 * An avatar image is an internal component used to control the rendering phases of an image.
 */
export var TeamAvatarImage = function TeamAvatarImage(_ref3) {
  var _ref3$alt = _ref3.alt,
    alt = _ref3$alt === void 0 ? '' : _ref3$alt,
    src = _ref3.src,
    size = _ref3.size,
    testId = _ref3.testId,
    rest = _objectWithoutProperties(_ref3, _excluded);
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    hasImageErrored = _useState2[0],
    setHasImageErrored = _useState2[1];

  // If src changes, reset state
  useEffect(function () {
    setHasImageErrored(false);
  }, [src]);
  if (!src || hasImageErrored) {
    return jsx("span", {
      css: [avatarDefaultIconStyles, nestedAvatarStyles[size]]
    }, jsx(TeamIcon, {
      label: alt,
      primaryColor: ICON_BACKGROUND,
      secondaryColor: ICON_COLOR,
      testId: testId && "".concat(testId, "--team")
    }));
  }
  return jsx("span", rest, jsx("img", {
    src: src,
    alt: alt,
    "data-testid": testId && "".concat(testId, "--image"),
    css: avatarImageStyles,
    onError: function onError() {
      return setHasImageErrored(true);
    }
  }));
};